import React from "react";
import "../../theme/styles.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import WashPackages from "../../components/WashPackages";
import AppContainer from "../AppContainer";

const DetailerPackages = () => {
  return (
    <AppContainer>
      <WashPackages />
    </AppContainer>
  );
};

export default DetailerPackages;



// WEBPACK FOOTER //
// ./src/screens/detailer/DetailerPackages.js